import { createFileRoute } from '@tanstack/react-router';

import { FlashPage } from '../modules/flash/ui/pages/FlashPage';

export const Route = createFileRoute('/_authenticated/flash')({
  component: FlashPage,
});
